// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1jRQ8","productName":"Table_productName__180hr"};